import {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";

import { ProductReducer } from "../Reducer/ProductReducer.jsx";
import { FiltersReducer } from "../Reducer/FiltersReducer.jsx";
import { AuthContext } from "./AuthContext.jsx";
import { OrderReducer, intialOrderState } from "../Reducer/OrderReducer.jsx";
import { GET, GETWITHOUTNODATA, GETWITHOUTVALIDATE, GetWithResponse, POST } from "../Network/snpaxios.jsx";
import { FAILED, IMAGE_URL, OfferType, WEBSITE_SHOP_HASH } from "../Utils/constant.js";
import { buildProductFilter, encode, isEmpty, printDebugLog } from "../Utils/utils.js";
import { toast } from "react-toastify";
import { showActionToast } from "../Component/global/ActionToast.jsx";
import { updateTotalBasedOnCoupon } from "../Utils/cartUtils.jsx";

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const productInitialState = {
    originalProducts: [],
    products: [],
    cart: [],
    cartIds: [],
    wishlist: [],
    wishlistIds: [],
    categories: [],
    newArrivalProducts: [],
    maxMinPrice: [],
    listMovementType: [],
    listPersons: [],
    orders: [],
  };

  const filtersInitialState = {
    priceRange: [],
    categoryFilter: [],
    ratingFilter: "",
    sortByPriceFilter: "",
    filterListMovementType: "",
    filterListPersons: "",
    filterConditions: "",
    brandFilter: [],
  };
  const { authState, loader, setLoader, authDispatch } = useContext(AuthContext);


  const handlePayment = (requestKey, mBillNo) => {
    const payload = {
      label: 'Quick Pay',
      requestKey: requestKey,
      jobType: 1,
      ts: Math.floor(Date.now() / 1000),
      paymentJobLabel: "Quick Pay",
      redirectUrl: `${window.location.origin}/pay-verify`,
    };
    printDebugLog("handlePayment payload: ", payload);
    const encoded = btoa(JSON.stringify(payload));
    printDebugLog("handlePayment encoded payload: ", encoded);
    localStorage.setItem("pay-bill", mBillNo);

    const url = `https://payment.snpnextgen.com/pay?data=${encoded}`;
    //const localUrl = `http://localhost:3000/pay?data=${encoded}`;
    window.location.href = url;
    //window.location.href = localUrl;
  };

  const [showFilters, setShowFilters] = useState(false);
  const toggleShowFilters = () => {
    printDebugLog("toggleShowFilters last ,", showFilters);
    setShowFilters(!showFilters);
  };


  useEffect(() => {
    printDebugLog("ProductProvider", authState?.mobile);
    if (!isEmpty(authState.mobile)) {
      getUserProductWhislistCartUserId(authState.mobile);
    }
    setLoader(false);
  }, [authState?.mobile]);

  const [productState, productDispatch] = useReducer(
    ProductReducer,
    productInitialState
  );
  const [filtersState, filtersDispatch] = useReducer(
    FiltersReducer,
    filtersInitialState
  );

  const [isProfileTab, setIsProfileTab] = useState(true);
  const [orderState, orderDispatch] = useReducer(
    OrderReducer,
    intialOrderState
  );
  const [order, setOrder] = useState({});

  const getCategories = async () => {
    try {
      setLoader(true);
      const encodedShopHash = encode(WEBSITE_SHOP_HASH);
      const payLoad = await GET(`ext/cart/categories?shopHash=${encodedShopHash}`);
      if (payLoad !== null) {
        productDispatch({ type: "setCategories", payload: payLoad.categories });
      } else {
        console.error("getCategories", "null payload");
      }
      setLoader(false);
    } catch (err) {
      console.error("getCategories", err);
      setLoader(false);
    }
  };

  const getMaxMinPriceFilter = async (listCatgId = []) => {
    try {
      const data = {
        jcJson: {
          shopHash: encode(WEBSITE_SHOP_HASH),
          listCatgId: listCatgId
        },
      };
      const payLoad = await POST(`ext/cart/max-min-price-filter`, data);
      if (payLoad !== null) {
        productDispatch({ type: "setMaxMinPrice", payload: payLoad });
      } else {
        console.error("getMaxMinPriceFilter", "null payload");
      }
    } catch (err) {
      console.error("getMaxMinPriceFilter", err);
    }
  };

  const getListWatchFilter = async () => {
    try {
      const payLoad = await GET(`ext/cart/list-watch-filter`);
      if (payLoad !== null) {
        if (payLoad.listMovementType !== null && Array.isArray(payLoad.listMovementType)) {
          productDispatch({ type: "setMovementType", payload: payLoad.listMovementType });
        }
        if (payLoad.listPersons !== null && Array.isArray(payLoad.listPersons)) {
          productDispatch({ type: "setPersonType", payload: payLoad.listPersons });
        }
      } else {
        console.error("getListWatchFilter", "null payload");
      }
    } catch (err) {
      console.error("getListWatchFilter", err);
    }
  };

  const getNewArrivalProducts = async () => {
    try {
      const encodedShopHash = encode(WEBSITE_SHOP_HASH);
      const payLoad = await GETWITHOUTNODATA(`ext/cart/newly-uploaded-products?shopHash=${encodedShopHash}`);
      if (payLoad !== null) {
        productDispatch({ type: "setNewArrivalProducts", payload: payLoad.fullData });
      } else {
        console.error("getNewArrivalProducts", "null payload");
      }
    } catch (error) {
      console.error("getNewArrivalProducts", error);
    }
  };

  const getUserProductWhislistCartUserId = async (custMob) => {
    try {
      const encodedShopHash = encode(WEBSITE_SHOP_HASH);
      const payLoad = await GET(`ext/cart/get-user-cart-whislist-id?shopHash=${encodedShopHash}&custMob=${custMob}`);
      if (payLoad !== null) {
        if (Array.isArray(payLoad?.cartIds) && payLoad?.cartIds?.length > 0) {
          productDispatch({ type: "setCartIds", payload: payLoad.cartIds });
        }

        if (Array.isArray(payLoad?.wishlistIds) && payLoad?.wishlistIds?.length > 0) {
          productDispatch({ type: "setWishlistIds", payload: payLoad.wishlistIds });
        }

      } else {
        console.error("getUserProductWhislistCartUserId", "null payload");
      }
    } catch (error) {
      console.error("getUserProductWhislistCartUserId", error);
    }
  };

  const getSingleProductDetails = async (productID) => {
    try {
      const res = await GET(`ext/cart/singleProducts?inventoryId=${productID}`);
      if (res !== null) {
        return res;
      }

    } catch (err) {
      console.error("getSingleProductDetails", err);
      throw err;
    }
  };

  const getProducts = async (data) => {
    try {
      setLoader(true);
      const payLoad = await POST("ext/cart/products", data);
      if (payLoad !== null) {
        productDispatch({ type: "setTotalProducts", payload: payLoad.fullData });
      } else {
        console.error("getProducts", "null payload");
      }
    } catch (error) {
      console.error("getProducts", error);
      productDispatch({ type: "setTotalProducts", payload: [] });
    } finally {
      setLoader(false);
    }
  };

  const getOrderHistory = async (settleBill = false) => {
    try {
      setLoader(true);
      const data = {
        jcJson: {
          "shopHash": encode(WEBSITE_SHOP_HASH),
          "custMob": authState?.mobile,
          "settleBill": settleBill,
        }
      }
      const payLoad = await POST("ext/cart/order-history", data);
      if (payLoad !== null) {
        productDispatch({ type: "setOrderHistory", payload: payLoad.data });
      } else {
        console.error("getOrderHistory", "null payload");
      }
    } catch (error) {
      console.error("getOrderHistory", error);
      productDispatch({ type: "setOrderHistory", payload: [] });
    } finally {
      setLoader(false);
    }
  };

  const checkPaymentStatus = async (sessionKey, callback) => {
    const data = {
      jcJson: {
        requestKey: sessionKey,
      }
    };
    setLoader(true);
    //console.log("getEcartShopProduct  => ", data);
    const payLoad = await POST("external/check-pay-status", data);
    if (payLoad !== null) {
      const msg = payLoad?.msg;
      callback?.(msg);
    }
    setLoader(false);

  }

  const placeOrderProcess = async ({ mBillNo, mOrderId, paymentId, paymentSignature, navigate }) => {
    const data = {
      jcJson: {
        shopHash: encode(WEBSITE_SHOP_HASH),
        custMob: authState?.mobile,
        billNo: mBillNo,
        billStatus: 4/*PAID*/,
        bank_transactionId: paymentId,
        signature: paymentSignature,
        orderId: mOrderId,
      }
    };
    setLoader(true);
    //console.log("getEcartShopProduct  => ", data);
    const payLoad = await POST("cart/place-order", data);
    if (payLoad !== null) {
      silentRemovePaidcarts(mBillNo);
      orderDispatch({ type: "setOrderReset" });
      showActionToast({
        msg: `Order Initiated Successfully, Order no: ${mBillNo}`,
        positiveBtnText: "Ok!",
        onSubmit: () => {
          navigate?.();
        },
        negativeBtnText: null,
        onCancel: null,
      });
    } else {
      showActionToast({
        msg: "Some network error. Please try again!",
        positiveBtnText: "Try Again!",
        onSubmit: () => placeOrderProcess({ mBillNo: mBillNo, mOrderId: mOrderId, paymentId: paymentId, paymentSignature: paymentSignature }),
        negativeBtnText: null,
        onCancel: null,
      });
    }
    setLoader(false);
  }


  const createOrder = async (data, selectedAddress) => {
    try {
      setLoader(true);
      const mainData = {
        jcJson: {
          ...data,
        }
      }
      const payLoad = await POST("ext/cart/online-create-mart-order", mainData);
      if (payLoad !== null) {
        const paymentSessionId = payLoad.requestKey;
        const mBillNo = payLoad.billNo;
        handlePayment(paymentSessionId, mBillNo);
      } else {
        console.error("createOrder", "null payload");
      }
    } catch (error) {
      console.error("createOrder", error);
      toast.error("Error in creating order");
    } finally {
      setLoader(false);
    }
  }

  const getUpcomingTime = async () => {
    try {
      const res = await GetWithResponse(`watch/get-upcoming-time?shopHash=${WEBSITE_SHOP_HASH}`);
      if (res !== null) {
        return res;
      }
    } catch (err) {
      console.error("getUpcomingTime", err);
      throw err;
    }
    return { status: FAILED };
  }

  const getSocialConfigs = async (socialId) => {
    try {
      const res = await GETWITHOUTVALIDATE(`ext/get-social-configs?configName=${socialId}&shopHash=${WEBSITE_SHOP_HASH}`);
      if (res !== null) {
        if (!res.includes("status")) {
          return res;
        }
      }
    } catch (err) {
      console.error("getSocialConfigs", err);
      throw err;
    }
    return "";
  }

  const generateBillPdf = async (billNo) => {
    try {
      setLoader(true);
      const res = await GET(`ext/cart/generate-watch-bill?shopHash=${encode(WEBSITE_SHOP_HASH)}&billNo=${billNo}`);
      if (res !== null) {
        if (!isEmpty(res.path)) {
          window.open(`${IMAGE_URL}${res.path}`, "_blank", "noopener,noreferrer");
        }
      }

    } catch (err) {
      console.error("generateBillPdf", err);
    } finally {
      setLoader(false);
    }
  }

  const initiatePaymentAgain = async (billNo) => {
    try {
      setLoader(true);
      const res = await GET(`ext/cart/initiate-payment-again?shopHash=${encode(WEBSITE_SHOP_HASH)}&billNo=${billNo}`);
      if (res !== null) {
        const isPaymentInitiated = res?.isPaymentInitiated ?? false;
        if (!isPaymentInitiated) {
          toast.error("Payment initiation failed or expired. Contact support for assistance.");
          return;
        }
        const paymentSessionId = res.requestKey;
        handlePayment(paymentSessionId, billNo);
      }

    } catch (err) {
      console.error("initiatePaymentAgain", err);
      toast.error("Payment initiation failed. Please check your network connection.");
    } finally {
      setLoader(false);
    }
  }

  const silentRemovePaidcarts = async (billNo) => {
    try {
      const res = await GetWithResponse(`ext/cart/remove-paid-carts?shopHash=${encode(WEBSITE_SHOP_HASH)}&billNo=${billNo}`);
      printDebugLog("silentRemovePaidcarts response: " + billNo, res);
      productDispatch({ type: "setCartReset" });
      productDispatch({ type: "setCartIdsReset" });
      toast.success("All items removed from cart!");
    } catch (err) {
      console.error("silentRemovePaidcarts", err);
    }
  }

  const handleProductFilter = async () => {
    const data = buildProductFilter(
      filtersState.categoryFilter,
      // filtersState.priceRange,
      filtersState.brandFilter,
      // filtersState.sortByPriceFilter,
      filtersState.filterListMovementType,
      filtersState.filterListPersons,
      filtersState.filterConditions,
    );
    getProducts(data);
  }

  const verifyCoupon = async (couponInput) => {
    try {
      setLoader(true);
      const res = await GET(`watch/a2z-global-voucher-check?shopHash=${WEBSITE_SHOP_HASH}&voucherCode=${couponInput}&amt=${orderState.total}&mob=${authState?.mobile}&email=${authState?.email}`);
      if (res !== null) {
        const offerType = Number(res?.offerType ?? OfferType.No_Offer);
        const offerAmt = Number(res?.offerAmt ?? 0);
        updateTotalBasedOnCoupon(orderState, couponInput, offerType, offerAmt, orderDispatch);
      } else {
        updateTotalBasedOnCoupon(orderState, "", OfferType.No_Offer, 0.0, orderDispatch);
      }
    } catch (err) {
      console.error("verifyCoupon", err);
      updateTotalBasedOnCoupon(orderState, "", OfferType.No_Offer, 0.0, orderDispatch);
    } finally {
      setLoader(false);
    }
  }

  const userLogout = () => {
    localStorage.removeItem("custName");
    localStorage.removeItem("custMob");
    localStorage.removeItem("custEmail");
    authDispatch({ type: "setUser", payload: {} });
    authDispatch({ type: "setMobile", payload: "" });
    authDispatch({ type: "setAddress", payload: [] });
    productDispatch({ type: "setTotalReset" });
    toast.success("You're logged out!");
  };

  return (
    <ProductContext.Provider
      value={{
        productState,
        productDispatch,
        loader,
        filtersState,
        filtersDispatch,
        getSingleProductDetails,
        verifyCoupon,
        isProfileTab,
        setIsProfileTab,
        orderState,
        orderDispatch,
        order,
        setOrder,
        getProducts,
        getCategories,
        getNewArrivalProducts,
        getMaxMinPriceFilter,
        getListWatchFilter,
        handleProductFilter,
        getSocialConfigs,
        showFilters,
        toggleShowFilters,
        createOrder,
        getOrderHistory,
        getUpcomingTime,
        generateBillPdf,
        userLogout, setLoader, checkPaymentStatus, placeOrderProcess, initiatePaymentAgain
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
